import React from 'react';
import { Target, Euro, TrendingUp, Car } from 'lucide-react';

export function StatsBar({ t, displayedOpps, filteredListingsCount }) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 sm:gap-4 mb-4">
      <div className="bg-slate-800 rounded-xl p-3 sm:p-4 border border-slate-700">
        <div className="flex items-center gap-2 mb-1">
          <Target className="w-4 h-4 text-emerald-400" />
          <span className="text-xs text-slate-400">{t('opportunities')}</span>
        </div>
        <div className="text-2xl font-bold">{displayedOpps.length}</div>
      </div>
      <div className="bg-slate-800 rounded-xl p-3 sm:p-4 border border-slate-700">
        <div className="flex items-center gap-2 mb-1">
          <Car className="w-4 h-4 text-emerald-400" />
          <span className="text-xs text-slate-400">{t('totalListings')}</span>
        </div>
        <div className="text-2xl font-bold">{filteredListingsCount.toLocaleString()}</div>
      </div>
      <div className="bg-slate-800 rounded-xl p-3 sm:p-4 border border-slate-700">
        <div className="flex items-center gap-2 mb-1">
          <TrendingUp className="w-4 h-4 text-emerald-400" />
          <span className="text-xs text-slate-400">{t('avgProfitSaving')}</span>
        </div>
        <div className="text-2xl font-bold">
          {displayedOpps.length > 0
            ? (displayedOpps.reduce((sum, opp) => sum + parseFloat(opp.profitMargin), 0) / displayedOpps.length).toFixed(1)
            : 0}%
        </div>
      </div>
      <div className="bg-slate-800 rounded-xl p-3 sm:p-4 border border-slate-700">
        <div className="flex items-center gap-2 mb-1">
          <Euro className="w-4 h-4 text-emerald-400" />
          <span className="text-xs text-slate-400">{t('avgProfit')}</span>
        </div>
        <div className="text-2xl font-bold">€{displayedOpps.length > 0 ? Math.round(displayedOpps.reduce((s, o) => s + o.netProfit, 0) / displayedOpps.length).toLocaleString() : 0}</div>
      </div>
    </div>
  );
}

export default StatsBar;
